import(/* webpackMode: "eager" */ "/home/runner/_work/cm-ps-login-fe/cm-ps-login-fe/src/app/error.tsx");
